import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-row justify-content-center" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-12 text-center" }
const _hoisted_4 = { class: "h6" }

import { onMounted, ref, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import api from '@/services/BookingService';


export default /*#__PURE__*/_defineComponent({
  __name: 'BookConfirm',
  setup(__props) {

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const bookingCode = ref<string>('');
const loopActive = ref<boolean>(true);
let intervalId: number | null = null;

onMounted(() => {
    bookingCode.value = route.params.code as string || "";

    intervalId = setInterval(() => {
        if(loopActive.value){
            api.checkConfirmedBooking(bookingCode.value)
                .then((response: { data: boolean }) => {
                    if(response.data == true){
                        loopActive.value = false;
                        if (intervalId) {
                            clearInterval(intervalId);
                        }
                        router.push({ name: "summary" });
                    }
                })
                .catch((error: any) => {
                    console.error("Error confirming booking:", error);
                });
        }
    }, 3000);
});

// Cleanup interval on component unmount
onUnmounted(() => {
    loopActive.value = false;
    if (intervalId) {
        clearInterval(intervalId);
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("h2", null, _toDisplayString(_unref(t)("messages.bookingConfirmTitle")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_unref(t)("messages.bookingConfirmText")), 1)
      ])
    ])
  ], 64))
}
}

})